import { computed, Injectable, signal } from '@angular/core';

import { environment } from '@env';

/** `mock` — витрина из `public/mock-data/`, `api` — живые данные с бэкенда. */
export type DataSource = 'mock' | 'api';

const STORAGE_KEY = 'vasta.analytics.dataSource';

/** Источник переключается на лету из шапки; выбор запоминается между перезагрузками. */
@Injectable({ providedIn: 'root' })
export class DataSourceService {
  readonly source = signal<DataSource>(restore());

  readonly isMock = computed(() => this.source() === 'mock');

  set(source: DataSource): void {
    if (source === this.source()) {
      return;
    }

    this.source.set(source);

    try {
      localStorage.setItem(STORAGE_KEY, source);
    } catch {
      // Приватный режим браузера — выбор проживёт до перезагрузки.
    }
  }
}

function restore(): DataSource {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);

    if (saved === 'mock' || saved === 'api') {
      return saved;
    }
  } catch {
    // Хранилище недоступно — берём значение окружения.
  }

  return environment.useMockData ? 'mock' : 'api';
}
